import { BASE_URL } from "@/components/feature/Seo";

const siteName = "动漫网";
const url = BASE_URL;

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: siteName,
  url,
  description: "动漫网 - 动漫网全部动漫列表 / 动漫网新番索引，漫画分类大全与国漫日漫检索入口",
  logo: `${url}/vite.svg`,
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer service",
    email: "contact@anime.readdy.site",
    availableLanguage: ["zh-CN"],
  },
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: siteName,
  url,
  inLanguage: "zh-CN",
  description: "新番索引、漫画分类大全、国漫专区、日漫检索、动画库一站配齐的动漫资源聚合入口",
  publisher: organizationSchema,
};

export function breadcrumbSchema(items: { name: string; path: string }[]) {
  const base = url;
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${base}${item.path}`,
    })),
  };
}

export function articleSchema(payload: {
  title: string;
  description: string;
  date: string;
  author: string;
  image: string;
  path: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: payload.title,
    description: payload.description,
    datePublished: payload.date,
    dateModified: payload.date,
    author: { "@type": "Person", name: payload.author },
    image: payload.image,
    mainEntityOfPage: `${url}${payload.path}`,
    publisher: organizationSchema,
    inLanguage: "zh-CN",
  };
}

export function faqSchema(faqs: { question: string; answer: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };
}